import React, { useMemo, useState } from "react";
import "./DevicesList.scss";

interface Device {
  id: string;
  macAddress: string;
  serialNumber: string;
  modelNumber: string;
  status: string;
  batteryLevel: number;
  site: { SiteName: string };
  patient: { firstName: string; lastName: string };
  relatedHCP: { firstName: string; lastName: string };
}

const DevicesList = ({
  devices,
  firmwareVersion,
  checkUpdated,
}: {
  devices: Device[];
  firmwareVersion: string;
  checkUpdated?: boolean;
}) => {
  const [search, setSearch] = useState<string>("");

  const filteredDevices = useMemo(() => {
    if (!devices) return [];
    return devices.filter((device) =>
      device.macAddress.toLowerCase().includes(search.toLowerCase())
    );
  }, [devices, search]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };
  function checkIfDeviceUpdated(device: Record<string, any>) {
    return device.desiredSWVersion.firmwareVersionNumber === device.SWVersion;
  }
  return (
    <div className="devices-list-container">
      <div className="devices-header">
        <h2>Devices List</h2>
        <p>Firmware version: {firmwareVersion}</p>
      </div>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search Device"
          value={search}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>
      <div className="devices-table">
        <ul className="devices-list">
          {filteredDevices.map((device) => (
            <li
              key={device.id}
              className={`device-item ${
                checkUpdated
                  ? checkIfDeviceUpdated(device)
                    ? "green-dot-before"
                    : "red-dot-before"
                  : ""
              }`}
            >
              {device.serialNumber}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DevicesList;
